import React, { useState } from "react";
import { Label } from "../ui/label";
import { Loader2, Upload } from "lucide-react";
import { api, formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";

export function UploadField({ label, onUploaded, testid, accept = "audio/*", current = "" }) {
  const [busy, setBusy] = useState(false);
  const [name, setName] = useState("");
  const handle = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(data.storage_path);
      setName(file.name);
      toast.success("Uploaded");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div>
      {label && <Label className="text-xs text-[#A1A1AA]">{label}</Label>}
      <label className={`${label ? "mt-1" : ""} flex items-center gap-2 px-3 py-2 rounded border border-dashed border-white/15 cursor-pointer hover:border-[#C8A97E]/50 text-sm`}>
        {busy ? <Loader2 size={15} className="animate-spin" /> : <Upload size={15} />}
        <span className="truncate text-[#A1A1AA]">{name || current || (accept.includes("image") ? "Choose image" : "Choose audio file")}</span>
        <input type="file" accept={accept} className="hidden" onChange={handle} data-testid={testid} />
      </label>
    </div>
  );
}
